import { LitElement, html } from 'lit';
import { EXIST_BASE } from './eplib-constants.js';
import { BootstrapCSS } from '../resources/css/bootstrap.css';
import { EplibStyles } from '../resources/css/style.css.js';

/**
 * Manages off-canvas sidebar table of contents when viewing a text.
 *
 * @listens eplib-toggle-sidebar
 */

export class EplibTableOfContents extends LitElement {

  async firstUpdated() {
    super.firstUpdated();

    const doc = window.location.pathname.split('/').pop();
    const data = await this._getTableOfContents(doc);
    const html = this._buildTOC(data.toc, doc);
    this.shadowRoot.querySelector('.offcanvas-body').appendChild(html);

    this.addEventListener('eplib-toggle-sidebar', this._toggleSidebar);
    // this.addEventListener('click', event => this._navigate(event));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    // this.removeEventListener('click', event => this._navigate(event));
    this.removeEventListener('eplib-toggle-sidebar', this._toggleSidebar);
  }

  _toggleSidebar() {
    const sidebar = this.shadowRoot.getElementById('sidebar');
    if (sidebar) {
      const offcanvas = bootstrap.Offcanvas.getOrCreateInstance(sidebar);
      if (offcanvas) {
        offcanvas.toggle();
      }
    }
  }

  async _getTableOfContents(doc) {
    let url = `${EXIST_BASE}/modules/ajax-toc.xql?doc=${doc}`;
    try {
      const response = await fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin'
      });
      if (!response.ok) {
        throw new Error(`Network response was not OK: ${response.error}`);
      }
      const data = await response.json();
      if (data.error) {
        throw new Error("Data error: `${data.error}");
      }
      return data;
    }
    catch (error) {
      alert(`Error retrieving table of contents for ${doc}: ${error}`);
    }
  }

  _buildTOC(tocData, doc) {
    let ul = document.createElement('ul');
    if (tocData) {
      // If it's non-iterable, make it a single-element array.
      let toc = !!tocData[Symbol.iterator] ? tocData : Array.of(tocData);
      for (const entry of toc) {
        if (entry.pbid) {
          let a = document.createElement('a');
          a.setAttribute('class', 'toc-link');
          const page = entry.pbid.substring(entry.pbid.indexOf('-', entry.pbid) + 1);
          a.setAttribute('href', `${doc}?page=${page}` );
          a.innerHTML = entry.heading;
          a.onclick = () => this._navigate(a, this);
          let li = document.createElement('li');
          li.appendChild(a);
          if (entry.toc) {
            li.appendChild(this._buildTOC(entry.toc, doc));
          }
          ul.appendChild(li);
        }
      }
    }
    return ul;
  }

  _navigate(target, that) {
    const href = target.getAttribute('href');
    if (!href) { return; }
    const navEvent = new CustomEvent('eplib-navigate-page', {
      detail: {
        url: href,
        direction: 'nav-next',
        options: null
      },
      bubbles: true,
      composed: true
    });
    this.dispatchEvent(navEvent);
    that._toggleSidebar();
    return false;
  }

  render() {
    return html`
      <div>
        <div id="sidebar" class="offcanvas offcanvas-start" tabindex="-1">
          <div class="offcanvas-header">
            <h3 class="offcanvas-title">Contents</h3>
            <button type="button" class="btn-close text-reset" aria-label="Close" @click="${this._toggleSidebar}"></button>
          </div>
          <div class="offcanvas-body"></div>
        </div>
      </div>
    `;
  }

  static get styles() {
    return [
      BootstrapCSS,
      EplibStyles
    ];
  }
}


customElements.define('eplib-table-of-contents', EplibTableOfContents);